import { makeEnvironmentProviders } from '@angular/core';
import { Interceptor } from '@connectrpc/connect';
import { createGrpcWebTransport } from '@connectrpc/connect-web';
import { DebugService } from '@sites/util-environment';
import { INTERCEPTORS } from './interceptor.token';
import { TRANSPORT } from './transport.token';
import { logInterceptor } from './log.interceptor';

const noopInterceptor: Interceptor = (next) => (req) => next(req);

export function provideDataConnect(
  options: Omit<Parameters<typeof createGrpcWebTransport>[0], 'interceptors'>
) {
  return makeEnvironmentProviders([
    {
      provide: TRANSPORT,
      useFactory: (interceptors: Interceptor[]) =>
        createGrpcWebTransport({
          ...options,
          interceptors,
        }),
      deps: [INTERCEPTORS],
    },
    {
      provide: INTERCEPTORS,
      useFactory: (debug: DebugService) =>
        debug.isDebug() ? logInterceptor : noopInterceptor,
      deps: [DebugService],
      multi: true,
    },
  ]);
}
